// extracted by mini-css-extract-plugin
export default {"card":"Card_card__xcwuB","imageWrapper":"Card_imageWrapper__moe0Q","body":"Card_body__6XPKu"};